<template>
  <main class="contact-main">
    <div class="section-contact">
      <div class="section-form">
        <div class="form-header">
          <div class="form-title">Contact Us</div>
          <div class="form-subtitle">Fill out the form below to send us a message.</div>
        </div>

        <div class="form-fields">
          <input v-model="form.name" type="text" placeholder="Full Name" class="form-input" />
          <input v-model="form.email" type="text" placeholder="Email" class="form-input" />
          <input v-model="form.phone" type="text" placeholder="Phone" class="form-input" />
          <textarea
            v-model="form.message"
            placeholder="How can we help you?"
            class="form-textarea"
          ></textarea>

          <div class="privacy-text">
            Submitting this for you agree to our
            <a href="/terms" target="_blank">Privacy & Terms</a>
          </div>

          <button @click.prevent="send" class="send-button">Send</button>
        </div>
      </div>

      <div class="section-info">
        <div class="info-block">
          <div class="info-title">Call Us</div>
          <div class="info-subtitle">Call us anytime by phone on</div>
          <a href="tel:078389700" class="contact-item">07 838 9700</a>
        </div>

        <div class="info-block">
          <div class="info-title">Support</div>
          <div class="info-subtitle">
            If you have any concerns contact our head partner Dinu directly
          </div>
          <a href="tel:078389701" class="contact-item">07 838 9701</a>
        </div>

        <div class="info-block">
          <div class="info-title">General Questions</div>
          <div class="info-subtitle">Have a general question for us?</div>
          <div class="info-text">
            Contact reception at
            <a href="mailto:christine@slater.co.nz" class="contact-item">christine@slater.co.nz</a>
          </div>
        </div>
      </div>
    </div>

    <div class="section-location">
      <div class="section-text">
        <div class="location-title">Location</div>
        <div class="location-info">Level 1, 127 Collingwood Street</div>
        <div class="location-info">Hamilton 3204</div>
        <div class="location-info">Free parking at rear of the building</div>
      </div>

      <div class="section-map">
        <GoogleMap
          :center="center"
          :zoom="18"
          style="width: 100%; height: 400px"
          :api-key="mapKey"
          map-type-id="roadmap"
        >
          <Marker :options="{ position: center }" />
        </GoogleMap>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { GoogleMap, Marker } from 'vue3-google-map';

const center = ref({ lat: -37.7904910436618, lng: 175.2802241175592 });
const capkey = process.env.VUE_APP_CAPKEY;
const mapKey = process.env.VUE_APP_MAPKEY;
const sendClicked = ref(false);
const showRecaptcha = ref(true);

const form = ref({
  name: '',
  email: '',
  phone: '',
  message: '',
  verified: false,
  client: process.env.VUE_APP_CLIENT_EMAIL,
  contact: process.env.VUE_APP_CLIENT_NAME,
  domain: process.env.VUE_APP_DOMAIN,
});

onMounted(() => {
  document.title = 'Contact - Slater';
});

const send = async () => {
  if (sendClicked.value) return;
  if (!form.value.verified) {
    return console.log('form error');
  }

  sendClicked.value = true;
  try {
    await axios.post(`${process.env.VUE_APP_URLAPI}/emails/form/submit`, form.value, {
      timeout: process.env.VUE_APP_TIMEOUT,
    });
    form.value.verified = false;
    form.value.name = '';
    form.value.email = '';
    form.value.phone = '';
    form.value.message = '';
    sendClicked.value = false;
    console.log('form error');
  } catch (err) {
    sendClicked.value = false;
    console.log('form error');
  }
};
</script>

<style scoped>
.contact-main {
  display: flex;
  flex-direction: column;
}

.section-contact {
  display: flex;
  margin-right: 2vw;
  margin-top: 100px;
}

.section-form {
  width: 30vw;
  margin-left: 9vw;
  display: flex;
  flex-direction: column;
}

.section-info {
  width: 20vw;
  margin-left: 9vw;
  display: flex;
  flex-direction: column;
}

.form-header {
  margin-bottom: 50px;
}

.form-title {
  font-size: 38px;
  font-weight: 600;
  color: #213b55;
}

.form-subtitle {
  color: #213b55;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 18px;
}

.form-fields {
  display: flex;
  flex-direction: column;
}

.form-input {
  border-radius: 8px;
  width: 100%;
  color: #213b55;
  font-size: 15px;
  border: 1px solid rgb(213, 216, 218);
  height: 50px;
  padding: 5px 10px;
  margin-top: 20px;
}

.form-input:first-child {
  margin-top: 0;
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
  max-height: 200px;
  border-radius: 8px;
  width: 100%;
  color: #213b55;
  font-size: 15px;
  border: 1px solid rgb(213, 216, 218);
  padding: 5px 10px;
  margin-top: 20px;
}

.privacy-text {
  color: #213b55;
  margin-top: 20px;
  font-size: 18px;
}

.privacy-text a {
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-color: #13b5ea;
  font-weight: 600;
  font-size: 18px;
}

.recaptcha-wrapper {
  margin-top: 20px;
  margin-bottom: 20px;
}

.send-button {
  max-width: 200px;
  font-size: 15px;
  margin-right: 15px;
  border-radius: 4px;
  font-weight: 600;
  height: 40px;
  padding: 5px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #183043;
  background-color: #50dcaa;
  cursor: pointer;
  margin-top: 40px;
  border: none;
}

.info-block {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}

.info-title {
  font-size: 38px;
  font-weight: 600;
  color: #213b55;
}

.info-subtitle {
  color: #213b55;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
}

.info-text {
  color: #213b55;
  margin-bottom: 30px;
  font-size: 18px;
}

.contact-item {
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-color: #13b5ea;
  font-weight: 600;
  font-size: 18px;
  margin-right: 20px;
}

.section-location {
  margin-bottom: 100px;
  margin-top: 100px;
  display: flex;
  margin-left: 9vw;
  margin-right: 2vw;
}

.section-text {
  width: 30vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.section-map {
  margin-left: 2vw;
  width: 40vw;
}

.location-title {
  font-size: 38px;
  font-weight: 600;
  color: #213b55;
}

.location-info {
  color: #213b55;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
}

@media only screen and (max-width: 768px) {
  .section-contact {
    padding: 20px;
    margin-top: 50px;
    flex-direction: column;
  }

  .section-form,
  .section-info {
    width: 100%;
    margin-left: 0;
  }

  .section-info {
    margin-top: 50px;
  }

  .section-location {
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
    padding: 20px;
  }

  .section-text {
    width: 100%;
    text-align: center;
  }

  .section-map {
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
  }
}

@media only screen and (max-width: 480px) {
  .section-contact {
    flex-direction: column;
    padding: 20px;
    margin-top: 50px;
  }

  .section-form,
  .section-info {
    width: 100%;
    margin-left: 0;
  }

  .section-info {
    margin-top: 50px;
  }

  .section-location {
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
    padding: 20px;
  }

  .section-text {
    width: 100%;
  }

  .section-map {
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
  }
}
</style>
